import GPSSWitchVisualizer from "./visualizer";

/** pocet dostupnych formatu souradnic */
export const ALL_VISUALISERS: Array<GPSSWitchVisualizer> = [];

export function setFormat(index: number, caller?: GPSSWitchVisualizer) {
	// @ts-ignore
	Mapy.getComponent("gps").setFormatIndex(index);

	for (let iterator = 0; iterator < ALL_VISUALISERS.length; iterator++) {
		if (caller && caller === ALL_VISUALISERS[iterator]) {
			continue;
		}
		ALL_VISUALISERS[iterator].setFormatIndex();
	}
}
